import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMatterAllInfo } from "api";
import CaseFileView from "pages/CaseFile"; // reuse same component
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog } from "@progress/kendo-react-dialogs";
import { BiErrorCircle } from "react-icons/bi";
import Notifications from "components/layout/Notifications";

const StandaloneCaseFile = () => {
  const { id } = useParams();
  const [caseFileData, setCaseFileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCaseFile = async () => {
      try {
        const res = await getMatterAllInfo(id);
        setCaseFileData(res?.data?.data);
      } catch (err) {
        setErrorMsg("Case File not found or access denied.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchCaseFile();
  }, [id]);

  useEffect(() => {
    if (caseFileData && caseFileData.details) {
      document.title = `${caseFileData.matterRef} - ${caseFileData.details}`;
    }
  }, [caseFileData]);

  if (loading) {
    return (
      <Loader
        themeColor={"primary"}
        size={"large"}
        type={"infinite-spinner"}
        style={{ position: "absolute", top: "40%", left: "45%", zIndex: 999 }}
      />
    );
  }

  if (errorMsg) {
    return (
      <Dialog width={400} height={230}>
        <div className="d-flex flex-column justify-content-around align-items-center h-100 px-5 text-center">
          <BiErrorCircle color="red" size={"50px"} />
          <p style={{ fontWeight: "500", fontSize: "18px" }}>{errorMsg}</p>
          <button className="common-btn border-0" onClick={() => navigate("/")}>
            Close
          </button>
        </div>
      </Dialog>
    );
  }

  return (
    <div className="p-2 h-100 w-100 d-flex flex-column">
      <div
        className="d-flex justify-content-between align-items-center px-4 py-3"
        style={{ height: "50px" }}
      >
        <div className="app-bar-title">
          {caseFileData?.matterRef && caseFileData?.details && (
            <h5 className="fw-semibold mb-0">
              {caseFileData?.client?.clientName} - {caseFileData.matterRef} -{" "}
              {caseFileData.details}{" "}
              {caseFileData?.appCode && (
                <span> - [{caseFileData?.appCode}]</span>
              )}
            </h5>
          )}
        </div>

        <div>
          <Notifications />
        </div>
      </div>

      <div className="flex-grow-1 overflow-auto">
        <CaseFileView
          selTab={caseFileData?.matterRef}
          reference={caseFileData?.matterRef}
          id={caseFileData?.matterId}
          selectedid={caseFileData?.matterId}
          isStandAlone={true}
        />
      </div>
    </div>
  );
};

export default StandaloneCaseFile;
